import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    area: PropTypes.number.isRequired,
    buildableArea: PropTypes.number.isRequired
};

function PotentialUnitsText ({ area, buildableArea }) {
    function calculate () {
        return Math.ceil(((area * (buildableArea * 0.01)) * 0.25) / 130);
    }

    return calculate().toLocaleString(undefined, { maximumFractionDigits: 0 });
}

PotentialUnitsText.propTypes = propTypes;

export default PotentialUnitsText;